import {DeviceService} from '../shared/services/device.service';
import {
    IControlInput,
    IDeviceInformation,
    IDeviceItemGrouping,
    IDeviceItemVisitor,
    IDeviceNode,
    IDynamicControlsSharedState
} from '../shared/models/device';
import {
    CommandOptimizationRenderingService, CachedObject,
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';

// Visits a node that represent a control-input and adds the input to the
// the current grouping.
export class DeviceInputVisitor implements IDeviceItemVisitor {

    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;
    protected sharedState: IDynamicControlsSharedState;

    constructor(protected commandOptimizationRenderingService: CommandOptimizationRenderingService) {
    }

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState,
    ) {
        this.sharedState = sharedState;
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        let hasElementType = typeof propValue.elementType !== 'undefined';

        // This will have been set by an earlier visitor if we shouldn't visit
        let isContainer = propValue.$isContainer;

        return hasElementType && !isContainer;
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let controlInput = propValue as IControlInput;

        this.currentGrouping.$controlInputs.push(controlInput);

        controlInput.$fieldName = this.sharedState.nextId();
        this.service.setControlInputType(controlInput);

        this.commandOptimizationRenderingService.refreshCachedSensorAndBroadcastEventIfChanged(controlInput?.sensorId, controlInput as CachedObject);

        return null;
    }
}
